// LoadingSpinner.js
import React from 'react';

const styles = {
  container: {
    textAlign: 'center',
    padding: '20px'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  spinner: {
    color: '#006666',
    fontSize: '24px',
    marginBottom: '15px',
  },
  label: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#16537e'
  }
}

const LoadingSpinner = ({ loadingText }) => {
  const text = loadingText?.trim() || 'Loading data...';
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <i className='fas fa-spinner fa-spin' style={styles.spinner}></i>
        <p style={styles.label}>{text}</p>
      </div>
    </div>
  )
};

export default LoadingSpinner;
